<template>
    <v-layout class="wizard-layout d-flex flex-column" style="min-height: 100vh;">
        <div class="wizard-header d-flex justify-space-between align-center px-6 py-3">
            <div class="d-flex align-center ga-2">
                <v-img src="@/assets/images/logo-text.png" max-width="140" max-height="36" contain/>
            </div>
            <div class="d-flex align-center ga-2">
                <v-btn variant="text" color="grey-darken-1"
                       prepend-icon="mdi-close" @click="leaveWizard">
                    {{ onboardingStore.hasCompletedSetup ? 'Close' : 'Skip for now' }}
                </v-btn>
                <v-btn variant="text" color="grey-darken-1" prepend-icon="mdi-logout" @click="logout">
                    Log Out
                </v-btn>
            </div>
        </div>
        <v-main class="flex-grow-1 d-flex align-center justify-center" style="background: linear-gradient(135deg, #f5f7fa 0%, #e8edf5 100%);">
            <slot/>
        </v-main>
    </v-layout>
</template>

<script setup>
import {useAuthStore} from "@/stores/authStore";
import {useOnboardingStore} from "@/stores/onboardingStore";
import {useNavigation} from "@/composables/globals";

const authStore = useAuthStore();
const onboardingStore = useOnboardingStore();
const {navigateTo} = useNavigation();

const logout = () => {
    authStore.logout();
};

// Leaving without finishing has to stick, or the router redirect that sent them
// here (company admin with 0 devices) bounces them straight back.
const leaveWizard = () => {
    onboardingStore.dismissWizard();
    navigateTo('live-view');
};
</script>

<style scoped>
.wizard-header {
    background: white;
    border-bottom: 1px solid #e0e0e0;
    z-index: 10;
}
</style>
